module.exports = __webpack_public_path__ + "img/CM-DJ-25-Nissan-Playful.0f234480.jpg";